<template>
    <div>
        <v-row>
            <v-col>
                <v-skeleton-loader
                    class="mx-auto"
                    type="card"
                    v-if="loadingDealerAccount"
                ></v-skeleton-loader>
                <v-card v-else>
                    <v-card-title style="padding-top: 0px;padding-bottom: 0px;">Plan Corporativo</v-card-title>
                    <v-card-text style="padding-top: 0px;padding-bottom: 0px;">
                        <strong>Número de Cuenta:</strong> {{ dealerAccount.account_number }}
                        <strong>Folios disponibles:</strong> {{ dealerAccount.folios }}
                    </v-card-text>
                    <v-form
                        ref="form"
                    >
                        <v-card-text style="padding-top: 0px;padding-bottom: 0px;">
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        :color="themeColor"
                                        label="No. de cuenta o RUC a transferir"
                                        v-model="accountNumber"
                                        @blur="cargarNumeroCuenta"
                                        :loading="searchingAccount"
                                        :single-line="true"
                                    />
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        label="Folios a transferir"
                                        :rules="[rules.required, rules.numberBiggerCero]"
                                        v-model="form.folios"
                                        type="number"
                                    />
                                </v-col>
                                <v-col cols="3">
                                    <v-btn
                                        :color="themeColor"
                                        :disabled="disabledTransfer"
                                        :loading="form.busy"
                                        @click="generateMovement"
                                    >
                                        Transferir
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <vuetify-table
                    :headers="headers"
                    :api-u-r-l="apiURL"
                    :title="title"
                    :bus="bus"
                >
                <template v-slot:filters>
                    <v-row justify="center">
                        <v-col cols="12" sm="4">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                <v-icon
                                    :color="themeColor"
                                    @click="downloadExcel"
                                    v-on="on"
                                    x-large
                                    :loading="dowloading"
                                >
                                    mdi-download
                                </v-icon>
                                </template>
                                <span>Descargar Excel</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </template>
                </vuetify-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import Form from 'vform';
import VuetifyTable from '~/components/VuetifyTable';

export default {
    middleware: 'auth',
    metaInfo() {
        return { title: 'Distribuidores Asociados' };
    },
    components: {
        VuetifyTable,
    },
    data: () => ({
        headers: [
            {
                text: 'Distribuidor',
                value: 'name_associate',
                align: 'left',
                sortable: true,
            },
            {
                text: 'RUC',
                value: 'ruc_associate',
                align: 'left',
                sortable: true,
            },
            {
                text: 'No. Cuenta',
                value: 'account_number',
                align: 'left',
                sortable: true,
            },
            {
                text: 'Folios',
                value: 'folios',
                align: 'left',
                sortable: true,
            },
        ],
        dealerAccount: {},
        form: new Form({
            folios: 0,
            description: '',
            type_movement: 3,
            service_id: '',
            outgoing_account_id: '',
            incoming_account_id: '',
            dealer_id: '',
            account_ruc_dealer: '',
            busy: false,
        }),
        disabledTransfer: true,
        accountNumber: '',
        loadingDealerAccount: true,
        searchingAccount: false,
        bus: new Vue(),
        rules: {
            required: (v) => !!v || 'El campo es requerido.',
            numberBiggerCero: (v) => parseInt(v, 10) > 0 || 'El campo debe ser mayor a cero.',
        },
        dowloading: false,
    }),
    computed: {
        ...mapGetters({
            user: 'auth/user',
            themeColor: 'theme/themeColor',
        }),
        apiURL() {
            return `/api/catalogs/dealers/${this.user.dealer_id}/associate`;
        },
        title() {
            return 'Distribuidores asociados';
        },
    },
    async mounted() {
        await this.getDealerAccount();
    },
    methods: {
        getDealerAccount() {
        const url = 'api/account';
            window.axios.get(url)
                .then((response) => {
                response.data.items.forEach((item) => {
                    this.dealerAccount = item;
                    this.loadingDealerAccount = false;
                    this.form.dealer_id = this.dealerAccount.dealer_id;
                    this.form.outgoing_account_id = this.dealerAccount.id;
                });
            });
        },
        cargarNumeroCuenta() {
            const accountText = this.accountNumber.trim();
            this.disabledTransfer = true;
            if (this.dealerAccount.account_number
                && (accountText === this.dealerAccount.account_number || accountText === this.dealerAccount.identificacion)) {
                    this.accountNumber = '';
                    this.$store.dispatch('notifications/show', {
                        message: 'El número de cuenta o RUC no puede ser el suyo.',
                        type: 'error',
                    });
            } else {
                this.searchingAccount = true;
                const url = `/api/getAccount/${accountText}`;
                window.axios.get(url)
                .then((response) => {
                    if (response.data.type === 'success') {
                        this.form.incoming_account_id = response.data.item.id;
                        this.disabledTransfer = false;
                    }
                    this.searchingAccount = false;
                    this.$store.dispatch('notifications/show', {
                        message: response.data.message,
                        type: response.data.type,
                    });
                });
            }
        },
        resetForm() {
            this.$refs.form.reset();
        },
        generateMovement() {
            if (this.$refs.form.validate()) {
                this.form.busy = true;
                const url = '/api/history/store';
                window.axios.post(url, {
                    folios: this.form.folios,
                    description: this.form.description,
                    type_movement: this.form.type_movement,
                    service: this.form.service_id,
                    outgoing_account_id: this.form.outgoing_account_id,
                    incoming_account_id: this.form.incoming_account_id,
                    dealer_id: this.form.dealer_id,
                })
                .then((response) => {
                    this.type = response.data.type;
                    this.message = response.data.message;
                    this.form.busy = false;
                    this.resetForm();
                    this.getDealerAccount();
                    this.disabledTransfer = true;
                    if (this.type === 'success') {
                        this.bus.$emit('refreshTable');
                    }
                });
            }
        },
        downloadExcel() {
            this.dowloading = true;
            const url = '/api/download_excel_dealers_associated/export';
            window.axios({
                method: 'post',
                url,
                responseType: 'arraybuffer',
                data: {
                    dealerId: this.form.dealer_id,
                },
            }).then((response) => {
                this.downloadFile(response, `Reporte de Distribuidores Asociados  ${new Date().toISOString().slice(0, 10)}`);
                setTimeout(() => { this.dowloading = false; }, 1000);
            })
            .catch(() => {
                this.dowloading = false;
            });
        },
        downloadFile(response, filename) {
            // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
            // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
            // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
            const newBlob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
            // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
            }
            // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
            const data = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            link.href = data;
            link.download = `${filename }.xlsx`;
            link.click();
            setTimeout(() => {
                // Para Firefox es necesario retrasar la revocación de ObjectURL
                window.URL.revokeObjectURL(data);
            }, 100);
        },
    },
};
</script>

<style>

</style>
